<div class="custom-phone-input-component" [formGroup]="form">
  <span>
    <ngx-intl-tel-input ngDefaultControl [inputId]="inputId" [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
      [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
      [selectFirstCountry]="true" [phoneValidation]="phoneValidation" [maxLength]="16"
      [preferredCountries]="preferredCountries" [separateDialCode]="separateDialCode"
      [formControlName]="formControlNameCustom" name="custom" [customPlaceholder]="placeHolder" [cssClass]="customCssStr">
    </ngx-intl-tel-input>
  </span>
</div>